import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../Firebase";

export const defaultStats = [
  { id: 'stat-1', icon: 'Clock', num: 15, suffix: '+', label: 'Years of Experience', sub: 'Continuous industrial power operations nationwide.' },
  { id: 'stat-2', icon: 'Wrench', num: 1200, suffix: '+', label: 'Generators Installed', sub: 'Heavy-duty power backups engineered & delivered.' },
  { id: 'stat-3', icon: 'Clipboard', num: 450, suffix: '+', label: 'Active AMC Contracts', sub: 'Guaranteed SLA monitoring and preventive schedules.' },
  { id: 'stat-4', icon: 'Building', num: 300, suffix: '+', label: 'Corporate & Gov Clients', sub: 'Trusted power partner for tier-1 enterprises.' }
];

export const getGrowthStats = async () => {
  try {
    const docRef = doc(db, "site_content", "growth_stats");
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return docSnap.data().stats || defaultStats;
    }
    // Prepopulate
    await setDoc(docRef, { stats: defaultStats });
    return defaultStats;
  } catch (error) {
    console.error("Error fetching growth stats from Firestore: ", error);
    throw error;
  }
};

export const saveGrowthStats = async (stats) => {
  try {
    const docRef = doc(db, "site_content", "growth_stats");
    await setDoc(docRef, { stats });
  } catch (error) {
    console.error("Error saving growth stats to Firestore: ", error);
    throw error;
  }
};
